<template>
  <div class="AllBox">
    <van-sticky>
      <van-nav-bar
        fixed
        title="群聊成员"
        left-arrow
        safe-area-inset-top
        @click-left="onClickLeft"
      >
        <template #left>
          <div class="left-nr">
            <img src="../../assets/nav/yz_nav_fh.png" alt="" />
          </div>
        </template>
      </van-nav-bar>
    </van-sticky>

    <div class="mainBox">
      <van-field
        class="inputField"
        center
        placeholder="搜索群成员"
        v-model="state.inputText"
        :border="false"
      >
        <template #left-icon>
          <img src="@/assets/chat/chat_search.png" class="inputIcon" />
        </template>
      </van-field>

      <div class="managerBox">
        <p
          style="
            font-size: 12px;
            color: #fff;
            padding: 11px 31px 8px;
            margin-top: 12px;
          "
        >
          群主、管理员({{ state.managerUsers.length }}人)
        </p>

        <ul>
          <li
            v-for="(item, i) in state.managerUsers"
            :key="i + '-teamMembers'"
            @click="getMemberInfo(item)"
          >
            <!-- <img :src="getUserAvatr(item.account)" /> -->
            <img :src="item.avatar" />
            <p v-if="item.nickInTeam">{{ item.nickInTeam }}</p>
            <p v-else>{{ item.account }}</p>
            <span v-if="item.type == 'owner'">
              <img src="../../assets/chat/chat_group_groupOwner01.png" alt="" />
            </span>
            <span v-if="item.type == 'manager'">
              <!-- <span> -->
              <img
                src="../../assets/chat/chat_group_groupManager01.png"
                alt=""
              />
            </span>
          </li>
        </ul>
      </div>

      <div class="memberBox">
        <p
          style="
            font-size: 12px;
            color: #fff;
            padding: 11px 31px 8px;
            margin-top: 12px;
          "
        >
          <!-- 其他成员({{ state.memberUsers.length }}人) -->
          其他成员
        </p>
        <ul>
          <li
            v-for="(item, i) in state.memberUsers"
            :key="i + '-teamMembers'"
            @click="getMemberInfo(item)"
          >
            <!-- <img :src="getUserAvatr(item.account)" /> -->
            <img :src="item.avatar" />
            <p v-if="item.nickInTeam">{{ item.nickInTeam }}</p>
            <p v-else>{{ item.account }}</p>
            <!-- <div class="line"></div> -->
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, watch, onActivated } from "vue";
import { useRouter, useRoute } from "vue-router";
import SDK from "@yxim/nim-web-sdk";
import { useStore } from "vuex";
import { Local, IndexDB } from "@/utils/storage";
import touxiang from "@/assets/touxiang_reset.png";
export default {
  name: "GroupSetting",
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const state = reactive({
      notice: false,
      top: false,
      teamData: {},
      nim: null, 
      userID: store.state.wyAccount,
      inputText: "",
      myMap: new Map(), //创建map对象
      teamId: route.query.teamId,
      dataInfo: {
        myInfo: {},
        msgs: [],
        users: [],
        teamMembers: [],
        teams: [],
      },
      searchUsers: [],
      managerUsers: [],
      memberUsers: [],

      // 当前账号的权限
      myType: "",

      // 群成员账号信息
      memberId: [],

      // 本地存储的群成员信息
      // 群主和管理员分开的
      localTeamMember: [],
      // 全体成员
      allMembers: [],
    });

    // 搜索群成员的输入框监听
    watch(
      () => state.inputText,
      (val) => {
        // console.log(val);
        if (val == "") {
          state.memberUsers = state.dataInfo.teamMembers.filter((item) => {
            return item.type.match("normal");
          });
          state.managerUsers = state.dataInfo.teamMembers.filter((item) => {
            return item.type.match("owner") || item.type.match("manager");
          });
        } else {
          state.memberUsers = state.dataInfo.teamMembers.filter((item) => {
            return (
              item.type.match("normal") &&
              (item.nickInTeam.includes(val) || item.account.includes(val))
            );
          });
          state.managerUsers = state.dataInfo.teamMembers.filter((item) => {
            return (
              (item.type.match("owner") || item.type.match("manager")) &&
              (item.nickInTeam.includes(val) || item.account.includes(val))
            );
          });
        }
      }
    );
    const onClickLeft = () => {
      router.back();
    };
    //解散或退群
    const onQuit = () => {
      console.log("ddddddd");
      router.replace({ name: "simpleChat" });
      router.go(-1);
    };
    const goEditName = (uid, name) => {
      router.push({ path: "/GroupName", query: { uid: uid, name: name } });
    };
    const onTeams = (teams) => {
      console.log("群列表", teams);
      // mergeTeams:合并群组
      state.dataInfo.teams = state.nim.mergeTeams(state.dataInfo.teams, teams);
    };
    const onInvalidTeams = (teams) => {
      // cutTeams:删除退出的群组
      state.dataInfo.teams = state.nim.cutTeams(state.dataInfo.teams, teams);
      state.dataInfo.invalidTeams = state.nim.mergeTeams(
        state.dataInfo.invalidTeams,
        teams
      )
      ;
      refreshTeamsUI();
    };
    const onTeamMembers = async (obj) => {
      console.log("群成员数据-------------", obj);
      // 获取本地存储的用户信息数据
      // state.localTeamMember=Local.get('group-'+state.teamId)
      state.localTeamMember = await IndexDB.get("group-" + state.teamId);
      // console.log('本地存储的用户信息数据-----------',state.localTeamMember)
      if (state.localTeamMember) {
        state.allMembers = state.localTeamMember.admins.concat(
          state.localTeamMember.members
        );
      }

      // 对比获取到的群成员数据和本地存储的用户信息数据，添加头像和昵称
      // console.log('改名信息------',obj.members)
      obj.members.forEach((item) => {
        state.allMembers.forEach((item2) => {
          if (item.account == item2.accid) {
            if (!item2.avatar) {
              item.avatar = touxiang;
            } else {
              item.avatar = item2.avatar;
            }
            if (!item.nickInTeam) {
              item.nickInTeam = item2.nick;
            }
          }
        });
      });

      setTimeout(() => {
        // 同步群成员
        var members = obj.members;
        // console.log(members)

        // 对比群成员，找到当前账号的权限
        for (let index = 0; index < members.length; index++) {
          const element = members[index];
          if (element.account == state.userID) {
            state.myType = element.type;
          }
        }

        state.dataInfo.teamMembers = members;
        state.searchUsers = members;

        // console.log("群成员信息---------",members);

        state.memberUsers = members.filter((item) => {
          // console.log('群成员信息------------',item);
          return item.type.match("normal");
        });
        state.managerUsers = members.filter((item) => {
          // console.log('群成员信息------------',item.type.match("owner"));
          return item.type.match("owner") || item.type.match("manager");
        });
      }, 100);

      // 将群主放在第一位
      for (let index = 0; index < state.managerUsers.length; index++) {
        const element = state.managerUsers[index];
        console.log(element);
        if (element.type == "owner") {
          state.managerUsers.splice(index, 1);
          state.managerUsers.unshift(element);
        }
        // console.log('群主或管理员的数据----------',state.managerUsers)
      }
      refreshTeamMembersUI();
      // console.log("群成员总量" + JSON.stringify(state.dataInfo.teamMembers));
    };

    //用户资料
    const getUserDone = (error, user) => {
      console.log("错误信息----------------" + error);
      console.log(JSON.stringify(user) + "getUserDone");
      if (user.avatar) {
        if (user.avatar.length != 0 && user.avatar != null) {
          // console.log("666666666");
          state.myMap.set(user.account, user.avatar);
        }
      }

      // console.log("获取用户资料" + (!error ? "成功" : "失败"));
    };
    const onSyncTeamMembersDone = () => {
      console.log("同步群列表完成");
    };
    const onUpdateTeamMember = (teamMember) => {
      // console.log("群成员信息更新了", teamMember);
      onTeamMembers({
        teamId: teamMember.teamId,
        members: teamMember,
      });
    };
    const refreshTeamMembersUI = () => {
      // 刷新界面
    };
    const getTeamDone = (error, obj) => {
      // console.log("收到系统通知未读数", error);
      // console.log("获取群", obj);
      state.teamData = obj;
    };
    const getTeamMembersDone = (error, obj) => {
      console.log("获取群成员" + (!error ? "成功----->" : "失败"));
      if (!error) {
        onTeamMembers(obj);
      }
    };
    const updateMyInfoDone = (error, obj) => {
      // console.log(error);
      // console.log(obj);
      console.log("更新我的名片" + (!error ? "成功" : "失败"));
    };

    onMounted(() => {
      // console.log('路由携带的参数-------------',route.query);
      window.scrollTo(0, 0);
      // console.log("mounted");

      //初始化IM
      // this.nim = SDK.NIM.getInstance();
      state.nim = SDK.NIM.getInstance({
        // 初始化SDK
        debug: false,
        appKey: store.state.appKey,
        account: store.state.wyAccount,
        token: store.state.wyToken,
        debugLevel: "debug",
        db: false,
        onteams: onTeams,
        // onsynccreateteam: this.onCreateTeam,
        onteammembers: onTeamMembers,
        //onsyncteammembersdone: onSyncTeamMembersDone,
        onupdateteammember: onUpdateTeamMember,
      });
      setTimeout(() => {
        state.nim.getTeam({
          teamId: state.teamId,
          done: getTeamDone,
        });
        state.nim.getTeamMembers({
          teamId: state.teamId,
          done: getTeamMembersDone,
        });
        state.nim.updateMyInfo({
          // nickInTeam:store.state.nicename,
          avatar: store.state.avatar,
          // sign: 'newSign',
          // gender: 'male',
          // email: 'new@email.com',
          // birth: '1900-01-01',
          // tel: '13523578129',
          // custom: '{type: "newCustom", value: "new"}',
          done: updateMyInfoDone,
        });
      }, 300);
    });

    // 跳转群成员信息
    const getMemberInfo = (item) => {
      // console.log('点击的是哪个成员--------------',item);
      if (state.myType != "normal") {
        router.push({
          path: "/GroupMemberInfo",
          query: { teamId: item.teamId, account: item.account },
        });
      }
      // debugger
      // router.push({ path: "/GroupMemberInfo", query: { teamId: item.teamId,account:item.account } });
    };
    return {
      state,
      onClickLeft,
      onQuit,
      goEditName,
      onTeams,
      onInvalidTeams,
      onTeamMembers,
      getUserDone,
      onSyncTeamMembersDone,
      onUpdateTeamMember,
      refreshTeamMembersUI,
      getTeamDone,
      getTeamMembersDone,
      updateMyInfoDone,
      getMemberInfo,
    };
  },
};
</script>

<style scoped="scoped">
.AllBox {
  background-color: #161b1f;
}

.van-nav-bar {
  background: #161b1f;
}
.van-hairline--bottom::after {
  border: none;
}
:deep(.van-nav-bar__title) {
  color: #fff;
}
.mainBox {
  height: 100vh;
  overflow: auto;
  padding-top: 32px;
  padding-top: calc(120px + constant(safe-area-inset-top));
  padding-top: calc(120px + env(safe-area-inset-top));
}

.mainBox ul {
  background-color: #161b1f;
}

.mainBox ul li {
  background-color: #283138;
  margin: 24px 24px;
  padding: 23px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  position: relative;
}

.mainBox ul li p {
  font-size: 32px;
  margin-left: 24px;
  color: #fff;
}

.mainBox ul li img {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  margin-left: 24px;
}
.mainBox ul li span img {
  width: 56px;
  height: 22px;
  border-radius: 0;
}

.mainBox ul li .line {
  position: absolute;
  background-color: #ededed;
  height: 1px;
  width: 630px;
  top: 110px;
  left: 120px;
}

.inputField {
  height: 56px;
  border-radius: 28px;
  background-color: #283138;
  width: 686px;
  margin: 0 auto;
  display: flex;
  padding-left: 20px;
}

.inputIcon {
  width: 24px;
  height: 24px;
}

.left-nr img {
  width: 60px;
  height: 60px;
  margin-top: 5px;
}
.memberBox ul {
  padding-bottom: 100px;
}
</style>
